import { isDefined } from '@/utils/isDefined'

export const formatNumber = (number, inputProps) => {
  if (isDefined(number)) {
    if (inputProps) {
      if (inputProps.percentage) return `${preparePercentageValue(number, inputProps)}`
      if (inputProps.showPlain) return number
    }
    const parts = number.toString().split('.')
    parts[0] = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    if (parts[1] && parts[1].length) parts[1] = parts[1].slice(0, 3).padEnd(3, '0')
    return parts.join('.')
  }
  return ''
}

export const preparePercentageValue = (value, props = {}) => {
  const { numberOfDecimalDigits, integerOnly } = props
  if (isDefined(value)) {
    const result = (value * 100)
    if (integerOnly) { return Number(result.toFixed(0)) }
    if (isDefined(numberOfDecimalDigits)) { return Number(result.toFixed(numberOfDecimalDigits)) }
    return result
  }
  return null
}

export const isNumber = (value) => typeof value === 'number' && !Number.isNaN(value)

export const isInteger = (value) => Number.isInteger(value)

export const toIntOrNull = (value) => {
  if (typeof value === 'string') {
    value = parseInt(value, 10)
  }
  return typeof value === 'number' && !Number.isNaN(value) ? value : null
}

export const toFloatOrNull = (value) => {
  if (typeof value === 'string') {
    value = parseFloat(value)
  }
  return typeof value === 'number' && !Number.isNaN(value) ? value : null
}

const intRegEx = /^-?\d+$/
const BigInt = window.BigInt || ((val) => val)
const bigIntSupported = typeof window.BigInt === 'function'
export const dotNetMaxLong = BigInt('9223372036854775807')
export const dotNetMinLong = BigInt('-9223372036854775808')

export const isDotNetNullableLongCompatible = (value) => {
  return !value || isDotNetLongCompatible(value)
}
export const isDotNetLongCompatible = (value) => {
  if (typeof value === 'string') {
    if (!intRegEx.test(value)) return false
    if (bigIntSupported) {
      try {
        const v = BigInt(value)
        return v >= dotNetMinLong && v <= dotNetMaxLong
      } catch (err) {
        return false
      }
    }
  }
  if (typeof value === 'number') {
    return !isNaN(value) && value >= dotNetMinLong && value <= dotNetMaxLong
  }
  return false
}

export const dotNetMaxDecimal = BigInt('7922816251426433759354395034') // decimal.MaxValue / 10
export const dotNetMinDecimal = BigInt('-7922816251426433759354395034') // decimal.MinValue / 10
export const isDotNetNullableDecimalCompatible = (value) => {
  return !value || isDotNetDecimalCompatible(value)
}

export const isDotNetDecimalCompatible = (value) => {
  if (typeof value === 'string') {
    value = value.replace('.', '') // to allow typing dot when following digits are not written yet
    if (!intRegEx.test(value)) return false
    if (bigIntSupported) {
      try {
        const v = BigInt(value)
        return v >= dotNetMinDecimal && v <= dotNetMaxDecimal
      } catch (err) {
        return false
      }
    }
  }
  if (typeof value === 'number') {
    return !isNaN(value) && value >= dotNetMinDecimal && value <= dotNetMaxDecimal
  }
  return false
}



// WEBPACK FOOTER //
// ./src/utils/numberUtilities.js